import {makeObservable, observable} from "mobx";
import Logger from "./Logger";
import {AlertColor} from "@mui/material";

interface Notification {
    message: string
    // type: "error" | "warning" | "info" | "success",
    severity: AlertColor
    variant: "standard" | "filled" | "outlined"
}

interface NotifyOptions {
    color?: string
    severity: AlertColor
    headerContent?: string
}

class Notifier {
    infoColor: string = "#00a0ff";
    successColor: string = "#039d4c";
    warnColor: string = "#d48f00";
    errorColor: string = "#c50000";
    notifications: Notification[];
    private logger = new Logger("Notifier");

    constructor() {
        this.notifications = [];
        (window as any).nt = this;

        makeObservable(this, {
            notifications: observable,
        })


    }

    notify(message: string, values: any[], options: NotifyOptions) {
        values.forEach(value => {
            message = message.replace("%s", value);
        });

        // if (clear) {
        //     this.errors.length = 0;
        // }
        this.logger.error(message);
        this.notifications.push({message, severity: options.severity, variant: "filled"});

    }


    info(message: string, ...values: any[]) {
        this.notify(message, values, {color: this.infoColor, headerContent: "Info: ", severity: "info"});
    }

    success(message: string, ...values: any[]) {
        this.notify(message, values, {color: this.successColor, headerContent: "Success: ", severity: "success"});
    }

    warn(message: string, ...values: any[]) {
        this.notify(message, values, {color: this.warnColor, headerContent: "Warning: ", severity: "warning"});
    }

    error(message: string, ...values: any[]) {
        this.notify(message, values, {color: this.errorColor, headerContent: "Error: ", severity: "error"});
    }


    test(severity: AlertColor, message = "test") {
        this.notify(message, [], {severity});
    }
}

export const notifier = new Notifier();
